import React from 'react';
import { SKETCHPLAN_OPERATOR, SKETCHPLAN_PRICING_COPY, SKETCHPLAN_TURNAROUND } from '@rehub/pricing';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-1">
            <div className="mb-3">
              <img src="/cropped-Sketchplan-Logo1-removebg-preview.webp" alt="Sketchplan" className="h-10 w-auto object-contain object-left" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              Professional CAD-style floor plans from your sketch. You supply the measurements; our team redraws the plan.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-[#40E0D0] uppercase tracking-wider mb-3">Service</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Residential and commercial redraws</li>
              <li>{SKETCHPLAN_TURNAROUND.standardLabel}</li>
              <li>{SKETCHPLAN_PRICING_COPY.amendmentLong}</li>
              <li>JPG, PNG or PDF delivery</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-[#40E0D0] uppercase tracking-wider mb-3">How to order</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Order and pay first, then sign in to manage the project</li>
              <li>
                <a href="https://www.sketchplan.com/pricing" className="hover:text-[#40E0D0] transition-colors">
                  Full pricing
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-[#40E0D0] uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-[#40E0D0] transition-colors">
                  ReHub Studio
                </a>
              </li>
              <li>
                <a href="https://www.photoplan.co.uk" target="_blank" rel="noopener noreferrer" className="hover:text-[#40E0D0] transition-colors">
                  Photoplan
                </a>
              </li>
              <li>
                <a href="mailto:hello@sketchplan.com" className="hover:text-[#40E0D0] transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-[#40E0D0] transition-colors">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#40E0D0] transition-colors">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            © {year} {SKETCHPLAN_OPERATOR.name}. All rights reserved.
          </p>
          <p className="text-[11px] text-slate-600 max-w-xl text-center sm:text-right">
            {SKETCHPLAN_OPERATOR.relationship}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
